<template xmlns="http://www.w3.org/1999/html">
  <div class="mod-joylearning__offringlist}">
    <div class="assessment-banner">
      <img alt="" src="@/assets/img/dc/banner.png" />
      <div class="assessment-info" v-if="dataDetail && dataDetail.userInfo">
        <span>姓名：</span><label>{{ dataDetail.userInfo.userName }}</label>
        <span>经销商：</span
        ><label> {{ dataDetail.userInfo.dealerName }}</label>
        <span>评估职位：</span
        ><label>{{ dataDetail.userInfo.recruitmentPosition }}</label>
      </div>
    </div>

    <div style="background: #ffffff">
      <!--      发展进度-->
      <div class="assessment-msg_1">
        <div style="background: #f9f9f9">
          <div>
            <div style="height: 20px"></div>
            <div style="height: 90px; margin: 0 80px 0 50px">
              <el-row>
                <el-col :span="4" style="font-weight: bold; font-size: 18px">
                  <div class="progress-title" style="padding: 15% 0 0 10px">
                    评估进度>
                  </div>
                </el-col>
                <el-col :span="2" v-if="dataDetail.step[0]">
                  <span
                    :class="{
                      disabledImg:
                        dataDetail.step[0].status === '10' ||
                        dataDetail.step[0].status === '40',
                    }"
                    style="text-align: center; display: block"
                    ><img alt="" width="60px" src="@/assets/img/ac/1223_1.png"
                  /></span>
                  <div style="height: 10px"></div>
                  <div class="acdc-step-title active">
                    {{ $t("assessment.improve") }}
                  </div>
                </el-col>
                <el-col :span="2" v-if="dataDetail.step[1]">
                  <span
                    v-if="
                      dataDetail.step[1].status === '10' ||
                      dataDetail.step[1].status === '40'
                    "
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_0_1.png"
                  /></span>
                  <span
                    v-if="
                      !(
                        dataDetail.step[1].status === '10' ||
                        dataDetail.step[1].status === '40'
                      )
                    "
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_0.png"
                  /></span>
                </el-col>
                <el-col :span="2" v-if="dataDetail.step[1]">
                  <span
                    v-if="
                      dataDetail.step[1].status === '10' ||
                      dataDetail.step[1].status === '40'
                    "
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_4_1.png"
                  /></span>
                  <span
                    v-if="
                      !(
                        dataDetail.step[1].status === '10' ||
                        dataDetail.step[1].status === '40'
                      )
                    "
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_4.png"
                  /></span>
                  <div style="height: 10px"></div>
                  <div
                    :class="[
                      'acdc-step-title',
                      {
                        active: !(
                          dataDetail.step[1].status === '10' ||
                          dataDetail.step[1].status === '40'
                        ),
                      },
                    ]"
                  >
                    {{ $t("protal.CapabilityAssessment") }}
                  </div>
                </el-col>
                <el-col :span="2" v-if="dataDetail.step[2]">
                  <span
                    v-if="
                      dataDetail.step[2].status === '10' ||
                      dataDetail.step[2].status === '40'
                    "
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_0_1.png"
                  /></span>
                  <span
                    v-if="
                      !(
                        dataDetail.step[2].status === '10' ||
                        dataDetail.step[2].status === '40'
                      )
                    "
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_0.png"
                  /></span>
                </el-col>
                <el-col :span="2" v-if="dataDetail.step[2]">
                  <span
                    v-if="
                      dataDetail.step[2].status === '10' ||
                      dataDetail.step[2].status === '40'
                    "
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_5_1.png"
                  /></span>
                  <span
                    v-if="
                      !(
                        dataDetail.step[2].status === '10' ||
                        dataDetail.step[2].status === '40'
                      )
                    "
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_5.png"
                  /></span>
                  <div style="height: 10px"></div>
                  <div
                    :class="[
                      'acdc-step-title',
                      {
                        active: !(
                          dataDetail.step[2].status === '10' ||
                          dataDetail.step[2].status === '40'
                        ),
                      },
                    ]"
                  >
                    {{ $t("finish") }}
                  </div>
                </el-col>
              </el-row>
              <div style="height: 10px"></div>
            </div>
          </div>
          <div style="height: 10px"></div>
        </div>
        <div style="height: 10px"></div>
      </div>
    </div>

    <div class="pkg-content">
      <!--      个人基本信息-->
      <div class="assessment-msg">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>个人基本信息</span>
          </div>
          <div>
            <el-row>
              <el-col :span="5" :lg="5" :xl="3">
                <span>宝龄</span
                ><label>{{ dataDetail.userInfo.bmwYear }}年</label>
              </el-col>
              <el-col :span="5" :lg="5" :xl="3">
                <span>当前职位</span
                ><label>{{ dataDetail.userInfo.currentPosition }}</label>
              </el-col>
              <el-col :span="8" :lg="10" :xl="5">
                <span>加入当前经销商日期</span
                ><label>{{ dataDetail.userInfo.orgJoinDate }}</label>
              </el-col>
            </el-row>
            <el-row style="margin-top: 15px !important">
              <!--          弹出新页面。 页面可以下载简历-->
              <a @click="openResume" class="addPointer">简历详情</a>
            </el-row>
          </div>
        </el-card>
      </div>
      <!--      能力评估-->
      <div class="assessment-msg">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>能力评估</span>
          </div>
          <div>
            <el-row>
              <el-col :span="5">
                <span>评估日期</span
                ><label>{{ dataDetail.expertEvaluation.signUpDate }}</label>
              </el-col>
              <el-col :span="6">
                <span>场地</span
                ><label>{{ dataDetail.expertEvaluation.signUpLocation }}</label>
              </el-col>
              <!-- <el-col :span="6" >
                <span>结果</span
                ><label>{{ dataDetail.expertEvaluation.result }}</label>
              </el-col> -->
              <el-col :span="6">
                <span>日期</span
                ><label>{{
                  dataDetail.expertEvaluation.recruitmentDate
                }}</label>
              </el-col>
              <el-col :span="2">
                <div style="position: absolute; right: 0">
                  <!-- 第三方是否已打分(1:已 0:未)-->
                  <el-button
                    v-if="
                      $hasPermission('ACDC0001000') &&
                      dataDetail.expertEvaluation.hasCompetencyScore === '0'
                    "
                    type="primary"
                    style="width: 100%"
                    @click="openOffering"
                    >评估报名
                  </el-button>
                  <el-button
                    v-if="
                      $hasPermission('ACDC0001007') &&
                      dataDetail.expertEvaluation.hasCompetencyScore === '1'
                    "
                    type="primary"
                    style="width: 100%"
                    @click="getACDC3info"
                    >查看评估结果
                  </el-button>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top: 15px !important">
              <el-col :span="24" :lg="24">
                <span>报告：</span
                ><label
                  ><a class="addPointer" @click="expertEvaluationDow">{{
                    dataDetail.expertEvaluation.fileName
                  }}</a></label
                >
              </el-col>
            </el-row>

            <!-- 新增隐私政策 -->
            <el-row
              style="margin-top: 15px !important"
              class="assessmentPolicyClick"
            >
              <el-col :span="15" :lg="15" :xl="15">
                <!-- selectable  10 显示  20 不显示-->
                <div
                  v-if="
                    $hasPermission('ACDC0001001') &&
                    dataDetail.expertEvaluation.selectable === '10'
                  "
                >
                  <el-checkbox
                    @change="assessmentPolicyClick"
                    v-model="assessDetailchecked"
                  ></el-checkbox>
                  <el-link
                    @click="viewPolicyOK"
                    type="primary"
                    :underline="false"
                    >同意评估用户查看本人能力评估报告 《隐私政策》</el-link
                  >
                    </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
        <div class="assessment-msg">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>发展中心</span>
          </div>
          <div>
            <el-row>
              <el-col :span="5">
                <span>课程完成情况</span
                ><label>{{
                  dataDetail.developCenter.courseCompleteStatus
                }}</label>
              </el-col>
              <el-col :span="5">
                <span>区域反馈</span
                ><label>{{ dataDetail.developCenter.feedBack }}</label>
              </el-col>
              <el-col :span="4">
                <span>状态</span
                ><label>{{ dataDetail.developCenter.status }}</label>
              </el-col>
              <el-col :span="4">
                <span>日期</span
                ><label>{{ dataDetail.developCenter.date }}</label>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <!-- 厂家备注 -->
      <div class="assessment-msg" v-if="factoryDesc">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t("assessment.factoryEvaluation") }}</span>
          </div>
          <p class="assessment-msg-desc-title">{{ factoryDesc }}</p>
          <p
            class="assessment-msg-desc-title assessment-msg-desc-title2"
            @click="downloadFactoryFile"
            v-if="factoryFile"
          >
            {{ $t("assessment.factoryFileTitle") }}
          </p>
        </el-card>
      </div>
      <!--      补充说明-->
      <div class="assessment-msg">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>补充说明</span>
          </div>
          <div>
            <div>
              如果您对于评估中心有疑问或建议，请发送邮件至：Trainingorganization.MT@bmw-brilliance.cn
              ，或拨打电话 010-8455 7402
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 弹窗, 政策 -->
    <assessmentDetailPolicy
      @func="assessmentDetailEmit"
      @funcNO="assessmentDetailEmitNO"
      ref="refAssessmentDetailPolicy"
    ></assessmentDetailPolicy>

    <!-- 弹窗, 政策 确定按钮 -->
    <assessmentDetailPolicyOK
      @func="assessmentDetailEmitOK"
      ref="refAssessmentDetailPolicyOK"
    ></assessmentDetailPolicyOK>
    <!-- 填出详细框 -->
    <el-dialog
      title="查看评估报告"
      :visible.sync="dialogAssessmentVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <div class="divDialog">
        <div style="font-weight: 700">
          {{ assessmentList.userName }}的关键管理岗相关信息
        </div>
        <el-divider></el-divider>
        <!-- 关键管理岗下拉 -->
        <div class="divWorkyes">
          <el-form
            label-position="top"
            :data="assessmentList"
            :model="assessmentList"
            ref="dataForm"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="与申请职位相关管理经验"
                  prop="managerialWorkingYears"
                >
                  <el-select
                    v-model="assessmentList.managerialWorkingYears"
                    clearable
                    disabled
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in jobApplication"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="汽车行业相关经验"
                  prop="relatedWorkingYears"
                >
                  <el-select
                    v-model="assessmentList.relatedWorkingYears"
                    clearable
                    disabled
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in jobApplication"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div style="height: 40px"></div>
        <div style="font-weight: 700">
          {{ assessmentList.userName }}的评估中心结果
        </div>
        <el-divider></el-divider>
        <div style="height: 20px"></div>

        <div class="capabilityItem">能力项打分:</div>
        <el-table
          :data="assessmentList.contentList"
          title=""
          :span-method="arraySpanMethod"
          :row-style="{ height: '10px' }"
          :cell-style="{ padding: '0px' }"
          :header-cell-style="headerStyle"
          style="font-size: 12px"
        >
          <el-table-column
            property="competencyItem"
            label="能力项"
          ></el-table-column>
          <el-table-column
            property="importanceLabel"
            label="重要项"
            width="80"
          ></el-table-column>
          <el-table-column
            property="subCompetencyItem"
            label="子能力项"
            width="120"
          ></el-table-column>
          <el-table-column property="address" label="能力等级">
            <el-table-column
              v-for="(item, index) in nengliArr"
              :key="index"
              :prop="item.prop"
              width="50"
              :label="item"
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-show="
                    assessmentList.contentList[scope.$index].isInput === '0'
                  "
                  v-model="
                    timeTip[scope.$index * nengliArr.length + index].value
                  "
                  disabled
                ></el-checkbox>
                <el-input-number
                  v-show="
                    assessmentList.contentList[scope.$index].isInput === '1'
                  "
                  v-model="assessmentList.contentList[scope.$index].inputResult"
                  :precision="1"
                  :step="0.5"
                  :max="5"
                  :min="0"
                  size="mini"
                  disabled
                ></el-input-number>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <div style="height: 20px"></div>
        <div>岗位基础要求总分：{{ assessmentList.baseLineTotalScore }}</div>
        <div>岗位目标要求总分：{{ assessmentList.targetLineTotalScore }}</div>
        <div>候选人能力项得分：{{ assessmentList.competencyScore }}</div>
        <!-- <div>评估中心结果：{{ assessmentList.assessmentResultLabel }}</div> -->

        <div style="height: 20px"></div>
        <div style="float: right">
          <el-button @click="dialogAssessmentVisible = false">关闭</el-button>
        </div>

        <div style="height: 30px"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import offeringBatchUp from "./assessentFileUp";
import assessmentDetailPolicy from "./assessmentDetailPolicy";
import assessmentDetailPolicyOK from "./assessmentDetailPolicyOK";
import AesUtil from "@/utils/aes_utils";

export default {
  name: "assessmentinfo",
  components: {
    "offering-batch-up": offeringBatchUp,
    assessmentDetailPolicy: assessmentDetailPolicy,
    assessmentDetailPolicyOK: assessmentDetailPolicyOK,
  },
  data() {
    return {
      dataForm: {
        file: "",
        interviewResult: "",
        recommend: "",
        remark: "",
        report: "",
        roleType: "",
      },
      // assessmentResult:'',
      // 评估结果
      dialogAssessmentVisible: false,
      // 能力项打分数据
      assessmentList: {},
      // 能力项分数
      nengliArr: [],
      jobApplication: [
        {
          value: "4",
          label: "5年以上",
        },
        {
          value: "3",
          label: "3-5年",
        },
        {
          value: "2",
          label: "1-3年",
        },
        {
          value: "1",
          label: "1年以下",
        },
      ],
      assessDetailchecked: false, // 隐私政策勾选状态

      // 10s政策
      assessmentDetailVisible: false,

      // 确定政策
      assessmentDetailOKVisible: false,

      isSubmit: false,
      rules: {
        interviewResult: [
          { required: true, message: "请选择评估结果", trigger: "change" },
        ],
        remark: [
          {
            min: 50,
            max: 500,
            message: "输入字符长度须在50~500位字符之间",
            trigger: "blur",
            required: true,
          },
        ],
      },
      fileList: [],
      dialogTableVisible: false,
      offeringBatchUpVisible: false,

      timeTip: [],
      //标题样式
      headerStyle: {
        padding: 0,
        "font-weight": "500",
        "font-size": "12px",
        height: "10px",
      },

      // recruitment/recruitmentDetail
      dataDetail: {
        userInfo: {},
        expertEvaluation: {},
        developCenter: {},
        step: [],
      },
      // 表格数据 测试数据  所有时间均为YYYY-MM-dd格式
      dataDetail_tmep: {
        recruitmentId: "1318865606882541570",
        userInfo: {
          bmwYear: "6年",
          currentPosition: "总经理",
          orgJoinDate: "2020-10-16",
          userId: "146405",
          userName: "仁丹", // 姓名
          dealerName: "深圳南方宝城", // 经销商
          recruitmentPosition: "客户关系经理", // 评估职位
          userCode: "DAN.REN",
          userCardNo: "UR00260020",
        },
        applyPost: {
          onJobDate: "2020-10-16",
          status: "已上岗",
        },
        developCenter: {
          date: "2020-10-16",
          feedBack: "通过",
          courseCompleteStatus: "已完成",
          status: "已完成",
        },
        regionalFeedBack: {
          id: "业务主键",
          date: "2020-10-16",
          status: "Pass",
          reportUrl: "附件url",
          report: "附件名",
          remarks: "推荐理由",
        },
        expertEvaluation: {
          result: "符合目标要求",
          signUpLocation: "上海",
          recruitmentDate: "2020-10-16",
          report: "能力评估报告",
          signUpDate: "2020-10-16",
          // 排期跳转 /learning/base/offeringinfo/page?page=1&limit=10&catalogId=29,&language=Cn
          // 附件 三个附件 附件名字 附件下载地址
          file: [
            {
              fileId: "id",
              fileName: "文件名字",
              fileType: "cn",
            },
            {
              fileId: "id",
              fileName: "文件名字",
              fileType: "en",
            },
            {
              fileId: "id",
              fileName: "文件名字",
              fileType: "list",
            },
          ],
        },
        onlineTest: {
          scenarioExamReport: "情景测试报告",
          personalityExamReport: "性格测试报告",
          scenarioExamCorrectRate: "90%",
          personalityExamRisk: "--",
          scenarioExamRiskTips: "低风险",
          // sceneReport?bizId=ff80808172318b0e0173ad1656d15a2d&bizType=1310415516350922755  ---- 情景测试报告
          // natureReport?bizId=ff80808172318b0e0173ad1656d15a2d&bizType=1310415516250259458 ---- 性格测试报告
          // 性格测试 和 情景测试传递参数 bizId=ff80808172318b0e0173ad1656d15a2d&bizType=1310415516250259458
          // bizId
          // bizType
          scenarioExamTaskId: "", // 情景测试任务id
          personalityExamTaskId: "", //性格测试任务id
        },
        // 10: 未开始
        // 20: 进行中
        // 30: 已完成
        // 40: 未通过
        step: [
          {
            jobId: "335",
            stepDescribe: "提交简历",
            recruitmentStepConfId: "1309376736125718529",
            step: "1",
            updateTime: null,
            id: "1316635688906698754",
            recruitmentId: "1316635687824568322",
            isCanEdit: "10",
            status: "30",
          },
          {
            jobId: "335",
            stepDescribe: "在线测评",
            recruitmentStepConfId: "1309376736318656513",
            step: "2",
            updateTime: null,
            id: "1316635688952836097",
            recruitmentId: "1316635687824568322",
            isCanEdit: "10",
            status: "30",
          },
          {
            jobId: "335",
            stepDescribe: "区域评估",
            recruitmentStepConfId: "1309376736381571073",
            step: "3",
            updateTime: null,
            id: "1316635688978001921",
            recruitmentId: "1316635687824568322",
            isCanEdit: "10",
            status: "20",
          },
          {
            jobId: "335",
            stepDescribe: "能力评估",
            recruitmentStepConfId: "1309376736461262849",
            step: "4",
            updateTime: null,
            id: "1316635688990584834",
            recruitmentId: "1316635687824568322",
            isCanEdit: "10",
            status: "10",
          },
          {
            jobId: "335",
            stepDescribe: "完成",
            recruitmentStepConfId: "1309376736528371713",
            step: "5",
            updateTime: null,
            id: "1316635689003167746",
            recruitmentId: "1316635687824568322",
            isCanEdit: "10",
            status: "10",
          },
        ],
      },
      factoryDesc: "",
      factoryFile: "",
      businessKey: 1,
    };
  },

  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getInfo();
  },
  created() {
    // this.getInfo()
    this.$eventHub.$on("showViewAssessmentDetail", (data) => {
      this.getInfo();
    });
    if (this.$hasPermission("ACDC0000001")) {
      this.dataForm.roleType = "acdcAdmin";
    } else if (this.$hasPermission("ACDC0000002")) {
      this.dataForm.roleType = "areaManager";
    }
  },
  methods: {
    //取消清空
    resetForm(formName) {
      if (this.dataDetail.step[2].status == "20") {
        this.$refs[formName].resetFields();
      }
      this.dialogTableVisible = false;
    },
    // 文件改变
    uploadChange(file, fileList) {
      this.fileList = fileList;
    },
    // 查询
    getInfo() {
      this.$request
        .post("/acdc/recruitment/queryRecruitmentDetail", {
          recruitmentId: this.$route.query.recruitmentId,
          userCode: this.$route.query.userCode,
          recruitmentPosition: this.$route.query.recruitmentPosition,
          roleType: this.dataForm.roleType,
        })
        .then((res, total, code, data) => {
          this.dataDetail = data.data;
          this.dataForm.remark = this.dataDetail.regionalFeedBack.remarks;
          this.dataForm.interviewResult =
            this.dataDetail.regionalFeedBack.status;
          // 获取厂家备注
          this.getFactoryDesc();
          //TODO 对政策勾选状态进行赋值
          if (data.data.expertEvaluation.viewReport === "1") {
            this.assessDetailchecked = true;
          }

            if (data.data.expertEvaluation.viewReport === '0') {
              this.assessDetailchecked = false
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      // 获取第三方打分详情
      getACDC3info() {
        this.$request
          .get('/acdc/recruitment/getByUserIdAndJobId2AssessmentDetail', {
            // recruitmentId: '0000000036e3e3980136e4a407320026'
            recruitmentId: this.dataDetail.recruitmentId
          })
          .then(data => {
            this.assessmentList = data
            // console.log('this.assessmentList')
            // console.log(this.assessmentList)
            this.dialogAssessmentVisible = true
            this.getAssessmentList()
            // console.log(this.assessmentList)
            // console.log(this.dataForm)
          })
          .catch((err) => {
            console.log(err)
          })
      },
      // 对分数动态赋值
      getAssessmentList: function () {
        let scoreCriteria = this.assessmentList.scoreCriteria;
        this.nengliArr = scoreCriteria.split(',')
        let userName = this.assessmentList.userName.substring(0, 1) + '**';
        this.assessmentList.userName = userName
        // console.log(this.timeTip)
        this.timeTip = []; //对空数组进行清空，以免影响后续操作
        let len = this.assessmentList.contentList.length;
        let nengliLength = this.nengliArr.length;
        for (let i = 0; i < len; i++) {
          for (let j = 0; j < nengliLength; j++) {
            let resultIndex = this.assessmentList.contentList[i].indexNum
            if (j + "" === resultIndex) {
              let item = {
                key: i + '_' + j,
                value: true
              }
              this.timeTip.push(item); //将处理好的数据循环放进数组中
            } else {
              let item = {
                key: i + '_' + j,
                value: false
              }
              this.timeTip.push(item); //将处理好的数据循环放进数组中
            }
          }
        }
        // console.log('timeTip')
        // console.log(this.timeTip)
      },

    sendFeedback() {
      if (this.dataDetail.step[2].status == "10") {
        this.$message.warning(`候选人完成在线测试后才可以进行填写`);
        this.dialogTableVisible = false;
      } else {
        this.dialogTableVisible = true;
      }
    },
    // 合并弹出框单元格
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.assessmentList.contentList[rowIndex].isInput === "1") {
        if (columnIndex === 3) {
          return [1, 9];
        }
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onSubmit() {
      if (this.fileList.length > 0) {
        this.$refs.upload.submit(); // 上传文件使用
      } else {
        this.uploadFile({});
      }
    },
    beforeUpload(file) {
      //文件格式校验
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      var fileExtenList = [
        "jpg",
        "png",
        "xlsx",
        "xls",
        "zip",
        "rar",
        "txt",
        "pdf",
      ];
      const extension = fileExtenList.find((item) => item == testmsg);
      const isLt2M = file.size / 1024 / 1024 < 4;
      if (!extension) {
        this.$message({
          message: "上传文件只能是 jpg,png,xlsx,xls,zip,rar,txt,pdf格式!",
          type: "warning",
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 4MB!",
          type: "warning",
        });
        return false;
      }
      return true;
    },
    // 在线测评跳转页面
    viewReport(type) {
      // 性格测试 natureReport?bizId=ff80808172318b0e0173ad1656d15a2d&bizType=1310415516250259458
      if (type === "nature") {
        this.$router.push({
          name: "acdc-report-natureReport",
          query: {
            bizId: this.dataDetail.recruitmentId,
            bizType: this.dataDetail.personalityExamTaskId,
          },
        });
      }
      // 情景测试 sceneReport?bizId=ff80808172318b0e0173ad1656d15a2d&bizType=1310415516350922755
      if (type === "scene") {
        this.$router.push({
          name: "acdc-report-sceneReport",
          query: {
            bizId: this.dataDetail.recruitmentId,
            bizType: this.dataDetail.scenarioExamTaskId,
          },
        });
      }
    },
    // 打开评估详情政策
    assessmentPolicyClick() {
      console.log(this.assessDetailchecked);
      // 点击打开政策
      if (this.assessDetailchecked) {
        this.$refs.refAssessmentDetailPolicy.init();
      } else {
        this.authViewReport();
      }
    },
    // 调用保存政策状态方法
    authViewReport() {
      let viewReport;
      if (this.assessDetailchecked) {
        viewReport = "1";
      } else {
        viewReport = "0";
      }
      this.$request
        .post("/acdc/recruitment/authViewReport", {
          id: this.dataDetail.recruitmentId,
          viewReport: viewReport,
        })
        .then((res, total, code, data) => {
          // 结束
          if (this.assessDetailchecked) {
            // this.$message.info('勾选政策')
          } else {
            this.$message.info("去掉勾选后，候选人将无法查看本人能力评估报告");
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      // 弹出确定的政策
      viewPolicyOK() {
        this.$refs.refAssessmentDetailPolicyOK.init()
      },

    // 政策回掉
    assessmentDetailEmit(data) {
      this.assessDetailchecked = data;
      this.authViewReport();
    },
    // 政策回掉 取消
    assessmentDetailEmitNO(data) {
      this.assessDetailchecked = data;
      this.authViewReport();
    },

    // 政策回掉 确定
    assessmentDetailEmitOK(data) {
      // this.assessDetailchecked = data
    },

    // 打开新页面 查看pdf简历. 可下载
    openResume() {
      //userid加密
      const base64url = require("base64-url");
      let aes = new AesUtil();
      let userId = "";
      if (this.dataDetail.userInfo.userId === "") {
        userId = "";
      } else {
        userId = base64url.encode(
          aes.encrypt(this.dataDetail.userInfo.userId + "")
        );
      }
      console.info("userId------" + userId);
      this.$router.push({
        name: "acdc-resume-resumePDF",
        query: {
          export: this.dataDetail.userInfo.userId,
          userId: userId,
          recruitmentId: this.dataDetail.recruitmentId,
          userName: this.dataDetail.userInfo.userName,
          orgName: this.dataDetail.userInfo.dealerName,
          jobName: this.dataDetail.userInfo.recruitmentPosition,
          isAssessment: "1",
        },
      });
    },

    //打开排期页面
    openOffering() {
      // /learning/base/offeringinfo/page?page=1&limit=10&catalogId=29,&language=Cn
      this.$router.push({
        name: "learning-offering-offeringlistdealerAdmin",
        query: {
          page: "1",
          limit: "10",
          catalogId: "29,",
          language: "Cn",
        },
      });
    },

    // 在线测评附件下载
    expertEvaluationDow() {
      this.$request.downloadLearning(
        "/acdc/fileManagement/downloadFile",
        this.dataDetail.expertEvaluation.fileName,
        {
          recruitmentId: this.dataDetail.recruitmentId,
        },
        null,
        true
      );
    },
    checkThirdStepIsComp() {
      //step
      // 10: 未开始
      // 20: 进行中
      // 30: 已完成
      // 40: 未通过
      if (
        this.dataDetail.step[2].status == "20" ||
        this.dataDetail.step[2].status == "10"
      ) {
        return false;
      }
      if (
        this.dataDetail.step[2].status == "30" ||
        this.dataDetail.step[2].status == "40"
      ) {
        return true;
      }
    },
    uploadFile(param) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$confirm("评估结果不可修改，是否确认提交?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              var fileObj = param.file;
              var form = new FormData();
              // FormData 对象
              // 文件对象
              form.append("file", fileObj);
              form.append("interviewResult", this.dataForm.interviewResult);
              form.append("recruitmentId", this.dataDetail.recruitmentId);
              form.append("remarks", this.dataForm.remark);
              let formData = {
                'file':param.file,
                'interviewResult': this.dataForm.interviewResult,
                'recruitmentId': this.dataDetail.recruitmentId,
                'remarks': this.dataForm.remark,
              }
              //form.append("report",'a.txt');
              this.$request.post(
                '/acdc/regionalinterviewresult/fillInRegionalInterviewResultNotFile', formData
              ).then(() => {

                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
                this.isSubmit = true;
                this.dialogTableVisible = false;
                this.getInfo()
              })

            }).catch((err) => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消删除'
              // });
              console.log(err)
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });

      },
      downloadRegionalFeedBackReport() {

        let requestUrl = window.SITE_CONFIG['apiBaseURL'] + '/acdc/regionalinterviewresult/downloadReport' + `?token=${this.getStorage(this.GLOBAL.TOKEN)}`
        let dlform = document.createElement('form')
        dlform.method = 'post'
        dlform.action = requestUrl
        let hdnFilePath = document.createElement('input')
        hdnFilePath.type = 'hidden'
        hdnFilePath.name = 'recruitmentId'
        hdnFilePath.value = this.dataDetail.recruitmentId
        dlform.appendChild(hdnFilePath)
        document.body.appendChild(dlform)
        dlform.submit()
        document.body.removeChild(dlform)
      },
      //关闭dialog  清空表单内容
      handleClose(done) {
        /*this.dataForm.remark = '';
        this.dataForm.interviewResult = '';*/
        if (this.dataDetail.step[2].status == '20') {
          this.$refs.ruleForm.resetFields();
        }
        this.dialogTableVisible = false;
      },
      // 获取厂家备注
      getFactoryDesc() {
        const base64url = require('base64-url')
        let aes = new AesUtil()
        let userid = JSON.parse(sessionStorage.getItem('v1user_data'))
        let userId = base64url.encode(aes.encrypt(userid.userId + ''));
        // if(this.dataDetail.userInfo.userId === ''){
        //   userId = '';
        // }else {
        //   userId = base64url.encode(aes.encrypt(this.dataDetail.userInfo.userId + ''))
        // }
        const params = {
          userId: userId
        }
        this.$request.get('/acdc/restrict/userRemarkMT', params)
          .then((res) => {
            this.factoryDesc = res.remark
            this.factoryFile = res.fileName
          })
      },
      // 厂家附件下载
      downloadFactoryFile() {
        const params = {
          fileName: this.factoryFile,
          businessKey: this.businessKey
        }
        const name = this.factoryFile.substring(0, this.factoryFile.indexOf('.pdf'))
        this.$request.downloadByPost2('/acdc/acdcCommon/downloadPDFWithWaterMark', name, params)
      }
    }
  }
</script>

<style lang="scss" scoped>
.assessment-msg_1 {
  margin: 0 50px;
  position: relative;
  .acdc-step-title {
    height: 20px;
    text-align: center;
    color: #696969;
    &.active {
      color: #1e68d4;
    }
  }
}

.fujianButton {
  padding: 3px 20px !important;
  border-radius: 5px !important;
}

.dialogTableClass .el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: -24px 0;
}

.divDialog .el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 1px 0;
}

.pkg-content {
  background-color: #f9f9f9;
  position: relative;
}

.assessment-msg {
  margin: 0 50px;
  padding: 10px 0;
  position: relative;
  .assessment-msg-desc-title {
    margin: 0;
    line-height: 26px;
    word-break: break-all;
    &.assessment-msg-desc-title2 {
      margin-top: 4px;
      color: #1c69d3;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.assessment-msg .assessment-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}

.assessment-msg span {
  font-weight: 600;
  margin-right: 20px;
}

.assessment-msg label {
  // font-weight: 600;
  /* margin-right: 60px; */
}

.assessment-msg .assessment-btn {
  position: absolute;
  right: 0;
  top: 50%;
  width: 150px;
  transform: translateY(-50%);
}

.pkg-search-box {
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 4px;
  overflow: hidden;
}

.el-dialog__body {
  padding: 5px 20px !important;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.el-dialog__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}

.assessment-banner {
  position: relative;
}

.assessment-banner img {
  display: inline-block;
  width: 100%;
}

.assessment-info {
  position: absolute;
  top: 10px;
  right: 10px;
}

.assessment-info span {
  font-weight: 600;
}

.assessment-info label {
  margin-right: 20px;
}

/*进度条 */
.assessment-progress {
  width: 80%;
  height: 10%;
  margin: 0 80px 0 100px;
  /*padding: 20px 0 40px 0;*/
  position: relative;

  .progress-title {
    position: absolute;
    top: 35.7%;
    left: -3%;
    font-weight: bold;
    font-size: 18px;
  }
}

.assessment-progress span {
  width: 19%;
  display: inline-block;
  margin-top: 15px;
  max-width: 268px;

  &:first-child {
    width: 20%;
  }
}

.assessment-progress span img {
  display: inline-block;
  width: 100%;
}

.assessment-progress .disabled {
  -webkit-filter: grayscale(100%);
  /* Chrome, Safari, Opera */
  filter: grayscale(100%);
  pointer-events: none;
}

.assessment-progress .disabledImg {
  -webkit-filter: grayscale(100%);
  /* Chrome, Safari, Opera */
  filter: grayscale(100%);
  pointer-events: none;
}

/* 弹出框*/
.assessment-result {
  margin-top: -30px;
  display: inline-block;
}

.assessment-result label {
  margin-right: 20px;
  white-space: nowrap;
  line-height: 40px;
}

.assessment-form {
  /*box-shadow: 0 0 5px #978787;*/
  /*padding: 20px 30px;*/
}

.assessment-form-label {
  font-size: 14px;
  margin-bottom: 20px;
  display: inline-block;
}

.assessment-form-label2:before {
  content: "*";
  color: #f56c6c;
}

.addPointer {
  cursor: pointer;
  text-decoration: none;
}
</style>
<style>
.assessmentPolicyClick .el-checkbox {
  font-size: 14px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 5px;
}
</style>
